export const projects = [
  // ================= PROFESSIONAL / FREELANCE =================
  {
    title: "KPRGTech",
    subTitle: "Freelance Software Development",
    duration: "2026 - Present",
    description:
      "Freelance development work delivering backend systems, automation tools, and AI-powered features for real-world clients.",
    techStack: ["Python", "Django", "PostgreSQL", "REST APIs", "Automation"],
    features: [
      "Client-based backend solutions",
      "API integrations",
      "Automation scripts",
      "Scalable system design"
    ],
    role: "Freelance Software Developer",
    liveLink: "https://kpregtech.com/",
    githubLink: "https://github.com/tushar-kumar-9354",
    type: "Professional Work",
    color: "#eef2ff"
  },

  {
    title: "SolarTech Gen",
    subTitle: "Professional Solar Technology Platform",
    duration: "2025 - 2026",
    description:
      "Professional backend development work for a solar-focused web platform with structured data handling and deployment.",
    techStack: ["Python", "Django", "PostgreSQL"],
    features: [
      "Backend workflows",
      "Database schema design",
      "Secure data handling"
    ],
    role: "Backend Developer",
    liveLink: "https://solar-29lr.onrender.com",
    githubLink: "https://github.com/tushar-kumar-9354",
    type: "Professional Work",
    color: "#fefce8"
  },

  // ================= PERSONAL / AI PROJECTS =================
  {
    title: "Resume Optimizer AI",
    subTitle: "AI-Powered Resume Analyzer",
    duration: "2024",
    description:
      "AI system that analyzes resumes, detects skill gaps, and recommends personalized projects and quizzes.",
    techStack: ["Python", "Django", "PostgreSQL", "Generative AI", "NLP"],
    features: [
      "Resume parsing",
      "Skill gap detection",
      "AI project suggestions",
      "Progress tracking"
    ],
    role: "Full Stack Developer",
    liveLink: "https://resume-optimizer-fcod.onrender.com",
    githubLink: "https://github.com/tushar-kumar-9354",
    type: "Personal Project",
    color: "#ecfeff"
  },

  {
    title: "AstroGPT",
    subTitle: "AI Astrology Assistant",
    duration: "2024",
    description:
      "AI-powered astrology assistant built using Generative AI for conversational insights and predictions.",
    techStack: ["Python", "Generative AI", "Gemini API"],
    features: [
      "Conversational AI",
      "Prompt-based responses",
      "Deployed AI service"
    ],
    role: "AI Developer",
    liveLink: "https://astro-gpt-2.onrender.com",
    githubLink: "https://github.com/tushar-kumar-9354",
    type: "Personal Project",
    color: "#fdf2f8"
  },

  {
    title: "Python Mastery",
    subTitle: "AI-Enhanced Learning Platform",
    duration: "2023",
    description:
      "Self-paced Python learning platform with AI assistants, quizzes, and concept-based progression.",
    techStack: ["Python", "Generative AI", "EdTech"],
    features: [
      "AI tutor",
      "Automated quizzes",
      "Personalized learning flow"
    ],
    role: "Developer",
    liveLink: "https://python-mastery.onrender.com",
    githubLink: "https://github.com/tushar-kumar-9354",
    type: "Personal Project",
    color: "#fafafa"
  },

  {
    title: "Civic Complaint Registration Portal",
    subTitle: "Civic-Tech Web Application",
    duration: "2023",
    description:
      "Platform for citizens to register and track complaints with role-based admin and user access.",
    techStack: ["Python", "Django", "PostgreSQL", "RBAC"],
    features: [
      "Complaint submission",
      "Admin dashboard",
      "Status tracking"
    ],
    role: "Backend Developer",
    liveLink: "https://complaint-registration-nnuw.onrender.com",
    githubLink: "https://github.com/tushar-kumar-9354",
    type: "Personal Project",
    color: "#f1f5f9"
  },

  {
    title: "GenAI Hub",
    subTitle: "Multi-Modal AI Playground",
    duration: "2024",
    description:
      "Central hub to experiment with text, image, audio, and chatbot use cases using Generative AI APIs.",
    techStack: ["Python", "Hugging Face", "Gemini API", "gTTS"],
    features: [
      "Multi-modal AI",
      "Prompt pipelines",
      "Reusable architecture"
    ],
    role: "AI Engineer",
    liveLink: null,
    githubLink: "https://github.com/tushar-kumar-9354",
    type: "Personal Project",
    color: "#f0fdf4"
  },

  {
    title: "Portfolio (Old)",
    subTitle: "Earlier Portfolio Showcase",
    duration: "2023",
    description:
      "My earlier personal portfolio showcasing initial projects and skill evolution.",
    techStack: ["HTML", "CSS", "JavaScript"],
    features: ["Project showcase", "Personal branding"],
    role: "Frontend Developer",
    liveLink: "https://tushar-portfolio-1.onrender.com",
    githubLink: "https://github.com/tushar-kumar-9354",
    type: "Personal Project",
    color: "#f8fafc"
  }
];

export const skillsData = {
  frontend: [
    // Expert
    { name: "HTML5", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg", level: "Expert" },
    { name: "CSS3", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-original.svg", level: "Expert" },
    
    // Advanced
    { name: "JavaScript", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg", level: "Advanced" },
    
    // Beginner
    { name: "React", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg", level: "Beginner" },
    { name: "Tailwind CSS", icon: "https://tailwindcss.com/_next/static/media/tailwindcss-mark.96ee6a5a.svg", level: "Beginner" },
    { name: "CodePen", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/codepen/codepen-original.svg", level: "Beginner" }
],

backend: [
    // Expert
    { name: "Python", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/python/python-original.svg", level: "Expert" },
    { name: "Django", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/django/django-plain.svg", level: "Expert" },
    { name: "FastAPI", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/fastapi/fastapi-original.svg", level: "Expert" },
    { name: "Django REST Framework", icon: "https://img.icons8.com/fluency/48/api.png", level: "Expert" },
    { name: "REST APIs", icon: "https://img.icons8.com/fluency/48/api.png", level: "Expert" },
    { name: "PostgreSQL", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/postgresql/postgresql-original.svg", level: "Expert" },
    { name: "SQLite", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/sqlite/sqlite-original.svg", level: "Expert" },
    { name: "Git", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-original.svg", level: "Expert" },
    { name : "selenium", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/selenium/selenium-original.svg", level: "Expert" },
    { name : "webscraping", icon: "https://img.icons8.com/fluency/48/web-scraping.png", level: "Expert" },
    // Advanced
    { name: "pandas", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/pandas/pandas-original.svg", level: "Advanced" },
    
    { name: "Celery", icon: "https://img.icons8.com/fluency/48/task.png", level: "Advanced" },
    { name: "Structured Logging", icon: "https://img.icons8.com/fluency/48/log.png", level: "Advanced" },
    
    // Intermediate
    { name: "Flask", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/flask/flask-original.svg", level: "Intermediate" }
],
aiSkills: [
  { 
    name: "Generative AI", 
    icon: "https://img.icons8.com/fluency/96/artificial-intelligence.png", 
    level: "Expert" 
  },
  { 
    name: "Prompt Engineering", 
    icon: "https://img.icons8.com/fluency/96/idea.png", 
    level: "Expert" 
  },
  { 
    name: "Large Language Models (LLMs)", 
    icon: "https://img.icons8.com/fluency/96/brain.png", 
    level: "Expert" 
  },    
  { name: "Gemini API", icon: "https://images.seeklogo.com/logo-png/61/1/gemini-icon-logo-png_seeklogo-611605.png", level: "Expert" },
  { 
    name: "LangChain", 
    icon: "https://img.icons8.com/color/96/chain.png", 
    level: "Expert" 
  },
  { 
    name: "AI Agents", 
    icon: "https://img.icons8.com/fluency/96/robot.png", 
    level: "Expert" 
  },
  { 
    name: "AI + Backend Integration", 
    icon: "https://img.icons8.com/fluency/96/server.png", 
    level: "Expert" 
  },
  
  { 
    name: "Agentic AI", 
    icon: "https://cdn.prod.website-files.com/67efa112fb94a795e40d92ee/6863a1206e0d5a21d2d71878_Untitled%20design%20(7).webp", 
    level: "Advanced" 
  },
  { 
    name: "Retrieval-Augmented Generation (RAG)", 
    icon: "https://www.weka.io/wp-content/uploads/files/2024/10/Retrieval-Augmented-Generation_featured-image.jpg", 
    level: "Advanced" 
  },
  { 
    name: "LangGraph", 
    icon: "https://img.icons8.com/fluency/96/workflow.png", 
    level: "Advanced" 
  },
  { 
    name: "Ollama", 
    icon: "https://images.seeklogo.com/logo-png/59/1/ollama-logo-png_seeklogo-593420.png", 
    level: "Advanced" 
  },
  { 
    name: "Natural Language Processing (NLP)", 
    icon: "https://img.icons8.com/fluency/96/chat.png", 
    level: "Advanced" 
  },
  { 
    name: "Sentiment Analysis", 
    icon: "https://img.icons8.com/fluency/96/positive-dynamic.png", 
    level: "Advanced" 
  },
  { 
    name: "Semantic Search", 
    icon: "https://img.icons8.com/fluency/96/search.png", 
    level: "Advanced" 
  },
  
  
  { name: "Fine-tuning LLMs", icon: "https://img.icons8.com/fluency/48/settings.png", level: "Advanced" },
   { name: "Hugging Face Transformers", icon: "https://huggingface.co/front/assets/huggingface_logo.svg", level: "Advanced" },
{ name: "OpenAI / GPT APIs", icon: "https://cdn.worldvectorlogo.com/logos/openai-2.svg", level: "Advanced" },
  { 
    name: "Text & Vector Embeddings", 
    icon: "https://img.icons8.com/fluency/96/vector.png", 
    level: "Advanced" 
  },
  { 
    name: "Speech-to-Text (Vosk)", 
    icon: "https://img.icons8.com/fluency/96/microphone.png", 
    level: "Advanced" 
  },
  { 
    name: "Text-to-Speech (gTTS)", 
    icon: "https://img.icons8.com/fluency/96/speaker.png", 
    level: "Advanced" 
  },
],

csFundamentals: [
    // Expert
    { name: "Data Structures & Algorithms", icon: "https://img.icons8.com/fluency/48/algorithm.png", level: "Expert" },
    { name: "Object-Oriented Programming (OOP)", icon: "https://img.icons8.com/fluency/48/class.png", level: "Expert" },
    { name: "DBMS", icon: "https://img.icons8.com/fluency/48/database.png", level: "Expert" },
    
    // Advanced
    { name: "Operating Systems", icon: "https://img.icons8.com/fluency/48/process.png", level: "Advanced" },
    { name: "Computer Networks", icon: "https://img.icons8.com/fluency/48/network.png", level: "Advanced" },
    { name: "Software Engineering", icon: "https://img.icons8.com/fluency/48/software-installer.png", level: "Advanced" }
]};


// Keep backward compatibility
export const backendSkills = skillsData.backend.map(skill => skill.icon);
export const frontEndSkills = skillsData.frontend.map(skill => skill.icon);